<!-- 计费方案详情 -->
<template>
  <div class="scheme-detail-box">
    <cmp-drawer :show="show" :title="title" @onClose="handleClose" @submit="hanleSubmit">
        <!-- 计费设置 -->
        <div class="scheme-title">计费设置</div>
        <div class="jifei-detail-box">
            <el-row :gutter="20">
                <el-col :span="12">
                    <div>
                        <div class="scheme-detail-title">供冷设置：</div>
                        <p class="scheme-jifei-item"><span>供水温度：</span><span>{{modelData.SupplyTempCool}}°C</span></p>
                        <p class="scheme-jifei-item"><span>回水温度：</span><span>{{modelData.BackTempCool}}°C</span></p>
                        <p class="scheme-jifei-item"><span>计费条件：</span><span>{{modelData.AllowTempCool}}°C</span></p>
                        <p class="scheme-jifei-item"><span>计费模式：</span><span>{{fmtIsAuto(modelData.IsAuto)}}</span></p>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div>
                        <div class="scheme-detail-title">供热设置：</div>
                        <p class="scheme-jifei-item"><span>供水温度：</span><span>{{modelData.SupplyTempHot}}°C</span></p>
                        <p class="scheme-jifei-item"><span>回水温度：</span><span>{{modelData.BackTempHot}}°C</span></p>
                        <p class="scheme-jifei-item"><span>计费条件：</span><span>{{modelData.AllowTempHot}}°C</span></p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 欠费设置 -->
        <div class="scheme-title">欠费设置</div>
        <el-row :gutter="20">
            <el-col :span="8">
                <div>
                    <div class="scheme-detail-title">后付费业主：</div>
                    <p class="scheme-jifei-item"><span>欠费额度：</span><span>{{modelData.CreditPercent}}%</span></p>
                </div>
            </el-col>
            <el-col :span="8">
                <div>
                    <div class="scheme-detail-title">预付费业主：</div>
                    <p class="scheme-jifei-item"><span>欠费金额：</span><span>{{modelData.CreditLine}}元</span></p>
                </div>
            </el-col>
            <el-col :span="8">
                <div>
                    <div class="scheme-detail-title">结算日：</div>
                    <p class="scheme-jifei-item"><span>日期：</span><span>{{modelData.AccountDay}}日</span></p>
                </div>
            </el-col>
        </el-row>
        <!-- 价格设置 -->
        <div class="scheme-title">价格设置</div>
        <div class="price-detail">
            <el-row :gutter="5">
                <el-col :span="8">
                    <p class="scheme-jifei-item"><span>基本费用：</span><span>{{modelData.BasePrice}}元/㎡*月</span></p>
                </el-col>
                <el-col :span="8">
                    <p class="scheme-jifei-item"><span>计费类型：</span><span>{{fmtExpenseType(modelData.ExpenseType)}}</span></p>
                </el-col>
                <el-col :span="8" v-show="modelData.ExpenseType === 1">
                    <p class="scheme-jifei-item"><span>时段类型：</span><span>{{fmtHolidayType(modelData.HolidayCharged, modelData.WeekendCharged, modelData.WorkingCharged)}}</span></p>
                </el-col>
                <el-col :span="8" v-show="modelData.ExpenseType === 2">
                    <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.BaseCoolPrice}}元/㎡*月</span></p>
                    <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.BaseHotPrice}}元/㎡*月</span></p>
                </el-col>
            </el-row>
            <div class="price-detail-item" v-show="modelData.HolidayCharged == 1">
                <div class="price-item-title">节假日：</div>
                <div class="price-item-con">
                    <p>{{modelData.Holiday}}</p>
                    <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.HolidayCoolPrice}}元/㎡*月</span></p>
                    <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.HolidayHotPrice}}元/㎡*月</span></p>
                </div>
            </div>
            <div class="price-detail-item" v-show="modelData.WeekendCharged == 1">
                <div class="price-item-title">周末：</div>
                <div class="price-item-con">
                    <p>{{fmtWeekend(modelData.SaturdayCharged,modelData.SundayCharged)}}</p>
                    <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.WeekendCoolPrice}}元/㎡*月</span></p>
                    <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.WeekendHotPrice}}元/㎡*月</span></p>
                </div>
            </div>
            <div class="price-detail-item" v-show="modelData.WorkingCharged == 1">
                <div class="price-item-title">工作日：</div>
                <div class="price-item-con">
                    <el-row :gutter="1">
                        <el-col :span="8">
                            <p>{{modelData.FirstTimeStart}} - {{modelData.FirstTimeEnd}}</p>
                            <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.FirstCoolPrice}}元/㎡*月</span></p>
                            <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.FirstHotPrice}}元/㎡*月</span></p>
                        </el-col>
                        <el-col :span="8">
                            <p>{{modelData.SecondTimeStart}} - {{modelData.SecondTimeEnd}}</p>
                            <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.SecondCoolPrice}}元/㎡*月</span></p>
                            <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.SecondHotPrice}}元/㎡*月</span></p>
                        </el-col>
                        <el-col :span="8">
                            <p>{{modelData.ThirdTimeStart}} - {{modelData.ThirdTimeEnd}}</p>
                            <p class="scheme-jifei-item"><span>冷量单价：</span><span>{{modelData.ThirdCoolPrice}}元/㎡*月</span></p>
                            <p class="scheme-jifei-item"><span>热量单价：</span><span>{{modelData.ThirdHotPrice}}元/㎡*月</span></p>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </cmp-drawer>
  </div>
</template>

<script>
import CmpDrawer from '@/components/CmpDrawer/CmpDrawer'
export default {
  name: "CmpSchemeDetail",
  props: ["show", "modelData"],
  data() {
    return {
        
    };
  },
  computed: {
      title () {
        return this.modelData.RuleName
      }
  },
  components: {
    CmpDrawer
  },
  created() {
      // console.log(this.modelData)
  },
  methods: {
    // 关闭添加设备
    handleClose(bool) {
      this.$emit("update:show", false);
    },
    // 确认添加设备
    hanleSubmit(data) {
        this.$emit("update:show", false);
    },
// 计费设置格式工具
    // 计费模式
    fmtIsAuto(key) {
        switch (key) {
            case 1:
                return '自动计费'
            case 2:
                return '手动计费'
            default:
                return ''
        }
    },
// 价格设置
    // 时段类型
    fmtExpenseType(key) {
        switch (key) {
            case 1:
                return '分时段计费'
            case 2:
                return '不分时段计费'
            default:
                return ''
        }
    },
    // 分段时间
    fmtHolidayType(HolidayCharged, WeekendCharged, WorkingCharged) {
        let arr = [];
        if( HolidayCharged === 1) {
            arr.push("节假日")
        }
        if( WeekendCharged === 1) {
            arr.push("周末")
        }
        if( WorkingCharged === 1) {
            arr.push("工作日")
        }
        return arr.join('、')
    },
    // 周末
    fmtWeekend(SaturdayCharged, SundayCharged) {
        let arr = [];
        if(SaturdayCharged === 1){
            arr.push("周六")
        }
        if(SundayCharged === 1){
            arr.push("周日")
        }
        return arr.join('、')
    }
  },
  watch: {
      modelData(newVal) {
        //   console.log(newVal);
      }
  }
};
</script>
<style lang='less' scoped>
    .scheme-detail-box{
        text-align: left;
        .scheme-title{
            color: #333;
            font-weight: 400;
            font-size: 18px;
            line-height: 36px;
            margin: 15px 0;
            position: relative;
            padding-left: 15px;
            background-color: #e8e8e8;
            &:first-child{
                margin-top: 0;
            }
            &:before{
                content: "";
                position: absolute;
                left: 0;
                bottom: 0;
                height: 36px;
                width: 4px;
                background-color: @primary-color;
            }
        }
        .scheme-detail-title{
            font-size: 14px;
            margin-left: 20px;
        }
        .scheme-jifei-item{
            font-size: 14px;
            line-height: 28px;
            margin-left: 40px;
            span{
                &:last-child{
                    margin-left: 20px;
                }
            }
        }
        .jifei-detail-box{

        }
        .price-detail{
            .price-detail-item{
                margin-bottom: 5px;
                overflow: hidden;
                .price-item-title{
                    float: left;
                    margin-left: 20px;
                }
                .price-item-con{
                   margin-left: 100px;
                }
            }
            .scheme-jifei-item{
                margin-left: 20px;
            }
        }
    }
</style>